export enum QuestionStatus {
  ACTIVE = "ACTIVE",
  LOADING = "LOADING",
  COMPLETE = "COMPLETE"
}
export const OfferJourneyStatusMapping: Record<string, QuestionStatus> = {
};
